module.exports = __webpack_public_path__ + "img/icon_user.8b7125d6.png";